import { SCORE_TIERS } from '@/lib/calculations'

interface BadgeProps {
  children: React.ReactNode
  variant?: 'default' | 'mso' | 'pso' | 'internal' | 'success' | 'warning' | 'danger' | 'neutral'
  className?: string
}

const VARIANT_CLASSES: Record<string, string> = {
  default: 'bg-slate-100 text-slate-600 dark:bg-slate-800 dark:text-slate-400',
  mso: 'bg-slate-100 text-slate-700 dark:bg-slate-800 dark:text-slate-300',
  pso: 'bg-slate-100 text-slate-700 dark:bg-slate-800 dark:text-slate-300',
  internal: 'bg-slate-100 text-slate-500 dark:bg-slate-800 dark:text-slate-400',
  success: 'bg-emerald-50 text-emerald-800 dark:bg-emerald-950/50 dark:text-emerald-300',
  warning: 'bg-amber-50 text-amber-800 dark:bg-amber-950/50 dark:text-amber-300',
  danger: 'bg-red-50 text-red-800 dark:bg-red-950/50 dark:text-red-300',
  neutral: 'bg-slate-100 text-slate-500 dark:bg-slate-800 dark:text-slate-400',
}

export default function Badge({ children, variant = 'default', className = '' }: BadgeProps) {
  return (
    <span className={`inline-block px-2 py-0.5 text-xs font-semibold ${VARIANT_CLASSES[variant]} ${className}`}>
      {children}
    </span>
  )
}

export function TierBadge({ tier, value, unit }: { tier: number; value: number | null; unit: string }) {
  if (tier < 0 || value === null) return <Badge variant="neutral">N/A</Badge>
  const t = SCORE_TIERS[tier]
  const display = Number.isInteger(value) ? value : value.toFixed(1)
  return <span className={`inline-block px-2 py-0.5 text-xs font-semibold ${t.color}`}>{display}{unit}</span>
}

export function CatBadge({ cat }: { cat: string }) {
  const v = cat === 'MSO' ? 'mso' : cat === 'PSO' ? 'pso' : 'internal'
  return <Badge variant={v}>{cat}</Badge>
}
